{
  "name": "@graphorin/core",
  "version": "0.15.1",
  "description": "Core types, contracts, and utilities for the Graphorin framework. Dependency-free root package every other @graphorin/* package depends on.",
  "license": "MIT",
  "author": "Oleksiy Stepurenko",
  "homepage": "https://github.com/o-stepper/graphorin/tree/main/packages/core",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/o-stepper/graphorin.git",
    "directory": "packages/core"
  },
  "bugs": {
    "url": "https://github.com/o-stepper/graphorin/issues"
  },
  "keywords": [
    "graphorin",
    "ai",
    "agents",
    "framework",
    "types",
    "contracts"
  ],
  "type": "module",
  "sideEffects": false,
  "engines": {
    "node": ">=22.12.0"
  },
  "main": "./dist/index.js",
  "module": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "default": "./dist/index.js"
    },
    "./types": {
      "types": "./dist/types/index.d.ts",
      "default": "./dist/types/index.js"
    },
    "./contracts": {
      "types": "./dist/contracts/index.d.ts",
      "default": "./dist/contracts/index.js"
    },
    "./utils": {
      "types": "./dist/utils/index.d.ts",
      "default": "./dist/utils/index.js"
    },
    "./channels": {
      "types": "./dist/channels/index.d.ts",
      "default": "./dist/channels/index.js"
    },
    "./package.json": "./package.json"
  },
  "files": [
    "dist",
    "src",
    "README.md",
    "CHANGELOG.md",
    "LICENSE"
  ],
  "scripts": {
    "build": "tsdown",
    "typecheck": "tsc --noEmit && tsc -p tsconfig.tests.json",
    "test": "vitest run",
    "lint": "biome check .",
    "clean": "rimraf dist .turbo *.tsbuildinfo"
  },
  "peerDependencies": {
    "zod": "^3.23.0 || ^4.0.0"
  },
  "peerDependenciesMeta": {
    "zod": {
      "optional": false
    }
  },
  "publishConfig": {
    "access": "public",
    "provenance": true
  },
  "devDependencies": {
    "zod": "^3.25.0"
  }
}
